(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const initialize = () => {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    let activeRequest;
    const applyPriceSort = async () => {
      activeRequest?.abort();
      const grid = container.querySelector('ul#product-grid');
      const url = new URL(window.location.href);
      const direction = url.searchParams.get('sort_by') || document.getElementById('SortBy')?.value;
      if (!grid || !['price-ascending', 'price-descending'].includes(direction)) return;
      const controller = new AbortController();
      activeRequest = controller;
      const currentPage = Number(grid.dataset.sortPage || 1);
      const pages = Number(grid.dataset.sortPages || 1);
      const pageSize = Number(grid.dataset.sortPageSize || grid.children.length);
      const cards = Array.from(grid.children);
      try {
        if (pages > 1) {
          grid.setAttribute('aria-busy', 'true');
          const queue = Array.from({length: pages}, (_, index) => index + 1).filter(page => page !== currentPage);
          await Promise.all(Array.from({length: Math.min(3, queue.length)}, async () => {
            while (queue.length) {
              const page = queue.shift();
              const pageUrl = new URL(url);
              pageUrl.searchParams.set('page', page);
              pageUrl.searchParams.set('section_id', grid.dataset.id);
              const response = await fetch(pageUrl, {signal: controller.signal});
              if (!response.ok) throw new Error('Unable to load price sorting');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const otherGrid = html.querySelector('ul#product-grid');
              if (!otherGrid) throw new Error('Missing collection page');
              cards.push(...otherGrid.children);
            }
          }));
        }
        if (controller.signal.aborted || !grid.isConnected) return;
        const multiplier = direction === 'price-descending' ? -1 : 1;
        const unique = [...new Map(cards.map(card => [card.dataset.sortProduct, card])).values()];
        unique.sort((a, b) => multiplier * (Number(a.dataset.sortPrice) - Number(b.dataset.sortPrice)) ||
          a.dataset.sortProduct.localeCompare(b.dataset.sortProduct));
        const start = (currentPage - 1) * pageSize;
        const visible = unique.slice(start, start + pageSize);
        visible.forEach((card, index) => {
          card.classList.add('scroll-trigger--cancel');
          card.style.setProperty('--animation-order', index + 1);
          card.querySelectorAll('.scroll-trigger').forEach(element => element.classList.add('scroll-trigger--cancel'));
        });
        grid.replaceChildren(...visible);
        grid.dataset.priceSorted = direction;
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      } finally {
        grid.removeAttribute('aria-busy');
      }
    };
    new MutationObserver(applyPriceSort).observe(container, {childList: true});
    applyPriceSort();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();

  } catch(e) { console.error(e); }
})();
})();
